import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Spinner, 
} from "reactstrap"
import { Link } from "react-router-dom"
import { get } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import moment from "moment";

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';


const Ppmactivity = props => {

  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState(null);

  const fetchData = () => {
    setLoading(true);
      console.log('RESP:');
      get(url.GET_PPMACTIVITY+'/'+props.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data);
        setLoading(false);
        }
      else {
        setData(null);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  React.useEffect(()=>{
    fetchData();
  }, []);


  return (
      <Modal isOpen={props.isOpen} toggle={props.toggle} size="lg" className="" centered>
        <ModalHeader toggle={props.toggle}>{data == null ? 'Property Details' : data.name}</ModalHeader>
        <ModalBody>
            { loading ? 
            <div style={{textAlign: 'center'}}>
                <Spinner color="primary" />
            </div> 
            :
            <div>
                { data == null ? 
                <div className="text-muted">Property could  not be loaded</div>
                :
                <table className="table table-striped table-hover">
                    <tbody>
                        <tr>
                            <td className="pb-4">Property Name</td>
                            <td className="pb-4">{data.name}</td>
                        </tr>
                        <tr>
                            <td className="pb-4">Date created</td>
                            <td className="pb-4">{moment(data.created_at).format('DD MMM YYYY, hh:mm a')}</td>
                        </tr>
                        <tr>
                            <td className="pb-4">Status</td>
                            <td className={"pb-4 "+(data.status == 1 ? 'text-success' : data.status == 0 ? 'text-danger' : '')}>{data.status == 1 ? 'Active' : 'Inactive'}</td>
                        </tr>
                    </tbody>
                </table>
                }
            </div>
            }
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={props.toggle}>Close</Button>
          
        </ModalFooter>
      </Modal>
  )
}

export default Ppmactivity
